import {TableCell, TableRow} from "@material-ui/core";
import {STTableCellTypography} from "@src/Components/Ui/STTableCellTypography";
import React from "react";
import {IApplicationBase} from "@src/Components/Pages/Main/Content/ApplicationsPage/Interfaces/interfaces";
import AppTableItemButtons from "./AppTableItemButtons/AppTableItemButtons";

interface IProps {
    app: IApplicationBase;
    isEnabled: boolean;
    onEditButtonClick: () => void;
    onRemoveButtonClick: () => void;
}

export const AppTableItem = ({app, isEnabled, onEditButtonClick, onRemoveButtonClick}: IProps) => (
    <TableRow hover key={app.clientId}>
        <TableCell size="small">
            <STTableCellTypography>{app.displayName}</STTableCellTypography>
        </TableCell>
        <TableCell size="small">
            <STTableCellTypography>{app.description}</STTableCellTypography>
        </TableCell>
        <TableCell align="center" size="small">
            <AppTableItemButtons
                isInternal={app.isInternal}
                isEnabled={isEnabled}
                onEditButtonClick={onEditButtonClick}
                onRemoveButtonClick={onRemoveButtonClick}
            />
        </TableCell>
    </TableRow>
)
